import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CsPage } from 'providers/nav-controller';
import { AuthRole } from '@cf-shared/couch-auth';
import { AuthService } from 'services/auth.service';
import { FormatNutrients } from 'util/formatting';
import { UserDb } from 'services/user-db.service';
import { Nutrients, INFOODS, NutrientTargets } from '@cf-shared/data-model/food';
import { UiDisplayNutrient } from 'models/display-nutrient';
import { NutrientListState } from 'components/nutrient-list/nutrient-list';

@Component({
    selector: 'page-test-ui-nutrients',
    templateUrl: 'test-ui-nutrients.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TestUiNutrientsPage extends CsPage<{}> {
  // Macro values
  calories: number = 1850;
  protein: number = 120;
  carbs: number = 180;
  fat: number = 65;
  fiber: number = 28;
  cholesterol: number = 250;

  // Macro targets
  caloriesTarget: number = 2000;
  proteinTarget: number = 150;
  carbsTarget: number = 200;
  fatTarget: number = 70;
  fiberTarget: number = 30;
  cholesterolTarget: number = 300;

  // All nutrient list states
  allStates: NutrientListState[] = [
    'inline-compact',
    'linear',
    'linear-card',
    'food-macros',
    'compact-macros'
  ];

  // Cached display nutrients
  displayNutrients: UiDisplayNutrient[] = [];

  constructor(
    protected auth: AuthService,
    private userDb: UserDb,
    private cd: ChangeDetectorRef
  ) {
    super();
  }

  async ionViewCanEnter() {
    await this.auth.pageAuthGuardAsync(AuthRole.Unknown);
  }

  async ionViewWillEnter() {
    this.updateNutrients();
    this.cd.markForCheck();
  }

  updateNutrients() {
    const nutrients: Nutrients = {
      [INFOODS.Calories]: this.calories || 0,
      [INFOODS.Protein]: this.protein || 0,
      [INFOODS.CarbNet]: this.carbs || 0,
      [INFOODS.Fat]: this.fat || 0,
      [INFOODS.Fiber]: this.fiber || 0,
      [INFOODS.Cholesterol]: this.cholesterol || 0
    };

    const targets: NutrientTargets = {
      [INFOODS.Calories]: { target: this.caloriesTarget || 0 },
      [INFOODS.Protein]: { target: this.proteinTarget || 0 },
      [INFOODS.CarbNet]: { target: this.carbsTarget || 0 },
      [INFOODS.Fat]: { target: this.fatTarget || 0 },
      [INFOODS.Fiber]: { target: this.fiberTarget || 0 },
      [INFOODS.Cholesterol]: { target: this.cholesterolTarget || 0 }
    };

    this.displayNutrients = FormatNutrients(nutrients, this.userDb, { targets });
    this.cd.markForCheck();
  }

  onInputChange() {
    this.updateNutrients();
  }
}
